import { render, staticRenderFns } from "./ComboPromocional.vue?vue&type=template&id=685ecb91&scoped=true&"
import script from "./ComboPromocional.vue?vue&type=script&lang=js&"
export * from "./ComboPromocional.vue?vue&type=script&lang=js&"
import style0 from "./ComboPromocional.vue?vue&type=style&index=0&id=685ecb91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685ecb91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
